export const MAX_EXPIRATION_DURATION_IN_MONTHS = 6;
